import request from '@/utils/request'

export function login (params) {
  return request.get('/HomePage')
}

export function logout () {
  return request.get('/logout')
}

export function modifyPassword (params) {
  return request.post('/modifyPassword', params)
}
/**
 * 友情链接列表
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function linksList (params) {
  return request.post('/web_api/webList', params)
}
/**
 * 查询网站配置
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function webConfigList (params) {
  return request.post('/web_api/list', params)
}

/**
 * 首页新闻 会议 活动列表
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function homeNewsList (params) {
  return request.post('/web_api/homeNewsList', params)
}
/**
 * 首页轮播
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function homeCarousel (params) {
  return request.post('/web_api/homeCarousel', params)
}
/**
 * 环保动态
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function homeEnvironmental (params) {
  return request.post('/web_api/homeEnvironmental', params)
}
/**
 * 研究资讯
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function homeInformation (params) {
  return request.post('/web_api/homeInformation', params)
}
/**
 * 头条推荐
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function homeHeadlines (params) {
  return request.post('/web_api/homeHeadlines', params)
}
/**
 * 低碳生活
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function homeLowCarbon (params) {
  return request.post('/web_api/homeLowCarbon', params)
}
/**
 * 首页平台伙伴
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function homePartner (params) {
  return request.post('/web_api/homePartner', params)
}
/**
 * 首页专家达人
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function homeExpert (params) {
  return request.post('/web_api/homeExpert', params)
}

/**
 * 研究领域
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function homeResearch (params) {
  return request.post('/web_api/homeResearch', params)
}

/**
 * 研究领域新闻
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function homeResearchNews (params) {
  return request.post('/web_api/homeResearchNews', params)
}


/**
 * 新资讯
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function informationList (params) {
  return request.post('/web_api/informationList', params)
}
/**
 * 低碳生活
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function lowCarbonLife (params) {
  return request.post('/web_api/low_carbon_life', params)
}

/**
 * 地球牧歌
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function earthPastoral (params) {
  return request.post('/web_api/earth_Pastoral', params)
}
/**
 * 专家达人
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function homeNewsExpert(params) {
  return request.post('/web_api/expert', params)
}
/**
 * 新闻详情
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function newsDetails(params) {
  return request.post('/web_api/newsDetails', params)
}


/**
 * 头条推荐
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function headlineNewsList(params) {
  return request.post('/web_api/headline_news_list', params)
}

/**
 * EDP
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function edpNewsList(params) {
  return request.post('/web_api/edp_new_list', params)
}

/**
 * EDP
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function selectNewsList(params) {
  return request.post('/web_api/selectNewsList', params)
}


/**
 * 平台伙伴
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function homeWholePartner(params) {
  return request.post('/web_api/homeWholePartner', params)
}
/**
 * 平台伙伴
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function appointPartner(params) {
  return request.post('/web_api/appointPartner', params)
}
/**
 * 平台伙伴新闻
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function homePartnerNews(params) {
  return request.post('/web_api/homePartnerNews', params)
}



